"use strict";

exports.__esModule = true;
exports.default = exports.attrAccept = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var attrAccept = function attrAccept(file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = file.type || '';
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType.toLowerCase());
      } else if (/\/\*$/.test(validType)) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

exports.attrAccept = attrAccept;

var Dragger =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Dragger, _PureComponent);

  function Dragger(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      dragType: ''
    };
    _this.handleFileDrop = _this.handleFileDrop.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Dragger.prototype;

  _proto.getMatchedFile = function getMatchedFile(files) {
    if (files === void 0) {
      files = [];
    }

    var accept = this.props.accept;
    return Array.prototype.slice.call(files).filter(function (file) {
      return attrAccept(file, accept);
    });
  };

  _proto.handleDrop = function handleDrop(e) {
    var _this$props = this.props,
        multiple = _this$props.multiple,
        addFile = _this$props.addFile;
    if (!addFile) return;
    var fileList = this.getMatchedFile(e.dataTransfer.files);
    if (!fileList || fileList.length <= 0) return;
    var files = multiple ? fileList : [fileList[0]];
    addFile({
      files: files,
      fromDragger: true
    });
  };

  _proto.handleFileDrop = function handleFileDrop(e) {
    var disabled = this.props.disabled;
    if (disabled) return;
    e.preventDefault();
    this.setState({
      dragType: e.type
    });
    if (e.type === 'drop') this.handleDrop(e);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        disabled = _this$props2.disabled;
    var dragType = this.state.dragType;
    return _react.default.createElement("div", {
      onDragOver: this.handleFileDrop,
      onDragLeave: this.handleFileDrop,
      onDrop: this.handleFileDrop,
      className: (0, _styles.uploadClass)('dragger-area', dragType === 'dragover' && 'dragger-hover', disabled && 'disabled')
    }, children);
  };

  return Dragger;
}(_component.PureComponent);

Dragger.propTypes = {
  children: _propTypes.default.any,
  multiple: _propTypes.default.bool,
  addFile: _propTypes.default.func,
  accept: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
var _default = Dragger;
exports.default = _default;